/** KDS Spinner — canonical 20×20 px arc at `md`; other sizes scale for app loading patterns. */
export const spinnerDefaultSize = 'md' as const;

/** Default arc fill — neutral/400 (#3D3D3D). */
export const spinnerDefaultColor = 'neutral.400';

export const spinnerSizes = ['inherit', 'xs', 'sm', 'md', 'lg', 'xl'] as const;

export type SpinnerSize = (typeof spinnerSizes)[number];
